export enum SwitchboardChildTab {
  SipTrunk = 'settings/switchboard/sip-trunk',
  IVR = 'settings/switchboard/ivr',
  Queue = 'settings/switchboard/queue',
}

export const SwitchboardTabList = [
  // {
  //   id: SwitchboardChildTab.SipTrunk,
  //   title: 'Sip trunk'
  // },
  {
    id: SwitchboardChildTab.IVR,
    title: 'IVR',
  },
  {
    id: SwitchboardChildTab.Queue,
    title: 'Hàng đợi',
  },
];
export function getCurrentTab(url) {
  let tab = '';
  Object.keys(SwitchboardChildTab).forEach(s => {
    if (url.includes(SwitchboardChildTab[s])) {
      tab = SwitchboardChildTab[s];
    }
  });
  return tab;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/switchboard.const.ts